'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var notificationTypes = {
  KYC_NOT_PASSED: 'KYC_NOT_PASSED',
  RISK_SCREEN_NO_ANSWER: 'RISK_SCREEN_NO_ANSWER',
  USER_PROFILE_UPDATE: 'USER_PROFILE_UPDATE',
  USER_DATA_CHANGED: 'USER_DATA_CHANGED',
  SP_ADMIN_APPLIED: 'SP_ADMIN_APPLIED',
  PASSED_KYC: 'PASSED_KYC',
  MANGOPAY_ACCOUNT_CREATED: 'MANGOPAY_ACCOUNT_CREATED',
  SP_USERS_CREATION_SUCCESSFUL: 'SP_USERS_CREATION_SUCCESSFUL',
  SP_DOCUMENT_UPLOAD_REQUEST: 'SP_DOCUMENT_UPLOAD_REQUEST',
  SP_DOCUMENT_UPLOAD_SUCCESSFUL: 'SP_DOCUMENT_UPLOAD_SUCCESSFUL',
  SP_DOCUMENT_UPLOAD_REJECTED: 'SP_DOCUMENT_UPLOAD_REJECTED',
  SP_USERS_CREATION_FAILED: 'SP_USERS_CREATION_FAILED',
  KYC_DOCUMENT_VALIDATED: 'KYC_DOCUMENT_VALIDATED',
  KYC_DOCUMENT_REFUSED: 'KYC_DOCUMENT_REFUSED',
  MANGOPAY_ACCOUNT_NOT_CREATED: 'MANGOPAY_ACCOUNT_NOT_CREATED',
  PROJECT_NDA_SIGNED: 'PROJECT_NDA_SIGNED',
  PROJECT_NDA_SIGNED_TO_RM: 'PROJECT_NDA_SIGNED_TO_RM',
  PROJECT_NDA_SIGNED_TO_EXTERNAL_POC: 'PROJECT_NDA_SIGNED_TO_EXTERNAL_POC',
  PROJECT_NDA_REQUESTED_TO_EXTERNAL_POC: 'PROJECT_NDA_REQUESTED_TO_EXTERNAL_POC',
  DATA_ROOM_ACCESS_REQUESTED_TO_RM: 'DATA_ROOM_ACCESS_REQUESTED_TO_RM',
  PROJECT_PUBLISHED_FOR_REVIEW: 'PROJECT_PUBLISHED_FOR_REVIEW',
  PROJECT_PUBLIC_MARKETPLACE_VISIBILITY: 'PROJECT_PUBLIC_MARKETPLACE_VISIBILITY',
  PROJECT_PUBLISHED: 'PROJECT_PUBLISHED',
  PROJECT_REJECTED: 'PROJECT_REJECTED',
  PROJECT_APPROVED: 'PROJECT_APPROVED',
  PROJECT_END_DATE_EDITED: 'PROJECT_END_DATE_EDITED',
  PROJECT_INVESTED: 'PROJECT_INVESTED',
  PROJECT_FULLY_INVESTED: 'PROJECT_FULLY_INVESTED',
  PROJECT_FINISHED: 'PROJECT_FINISHED',
  REJECTED_KYC: 'REJECTED_KYC',
  CO_SP_USER_KYC_CHECK_REQUEST: 'CO_SP_USER_KYC_CHECK_REQUEST',
  PROJECT_NOT_RECEIVED_TARGET_AMOUNT: 'PROJECT_NOT_RECEIVED_TARGET_AMOUNT',
  PROJECT_NOT_RECEIVED_TARGET_AMOUNT_FOR_INVESTOR: 'PROJECT_NOT_RECEIVED_TARGET_AMOUNT_FOR_INVESTOR',
  PAY_IN_TRANSACTION_SUCCESSFUL: 'PAY_IN_TRANSACTION_SUCCESSFUL',
  PAY_IN_TRANSACTION_FAILED: 'PAY_IN_TRANSACTION_FAILED',
  PAY_OUT_TRANSACTION_SUCCESSFUL: 'PAY_OUT_TRANSACTION_SUCCESSFUL',
  PAY_OUT_TRANSACTION_FAILED: 'PAY_OUT_TRANSACTION_FAILED',
  DATA_ROOM_ACCESS_REQUESTED: 'DATA_ROOM_ACCESS_REQUESTED',
  DATA_ROOM_ACCESS_GRANTED: 'DATA_ROOM_ACCESS_GRANTED',
  FIRST_TIME_VIEW: 'FIRST_TIME_VIEW',
  PROJECT_INVESTED_FOR_ISSUER: 'PROJECT_INVESTED_FOR_ISSUER',
  PROJECT_INVESTED_BY_ADVISOR: 'PROJECT_INVESTED_BY_ADVISOR',
  DATA_ROOM_ACCESS_REJECTED: 'DATA_ROOM_ACCESS_REJECTED',
  PROJECT_CREATOR_CONTACT_REQUEST: 'PROJECT_CREATOR_CONTACT_REQUEST',
  PROJECT_POC_CONTACT_REQUEST: 'PROJECT_POC_CONTACT_REQUEST',
  PROJECT_POC_CONTACT_REQUEST_WITH_INTERNAL_POC_DETAILS: 'PROJECT_POC_CONTACT_REQUEST_WITH_INTERNAL_POC_DETAILS',
  PROJECT_CLIENT_CONTACT_REQUEST: 'PROJECT_CLIENT_CONTACT_REQUEST',
  PROJECT_SP_CLIENT_CONTACT_REQUEST: 'PROJECT_SP_CLIENT_CONTACT_REQUEST',
  SUBSCRIPTION_EXPIRATION_AUTO_RENEW_OFF: 'SUBSCRIPTION_EXPIRATION_AUTO_RENEW_OFF',
  SUBSCRIPTION_EXPIRATION_AUTO_RENEW_ON: 'SUBSCRIPTION_EXPIRATION_AUTO_RENEW_ON',
  ACTIVE_SUBSCRIPTION_PRICE_CHANGED: 'ACTIVE_SUBSCRIPTION_PRICE_CHANGED',
  IN_QUEUE_SUBSCRIPTION_PRICE_CHANGED: 'IN_QUEUE_SUBSCRIPTION_PRICE_CHANGED',
  PROJECT_NDA_SIGNED_NOT_APPROVED: 'PROJECT_NDA_SIGNED_NOT_APPROVED',
  PROJECT_LIKED: 'PROJECT_LIKED',
  PROJECT_UNLIKED: 'PROJECT_UNLIKED',
  SP_SUBSCRIPTION_ACTIVATED: 'SP_SUBSCRIPTION_ACTIVATED',
  DEAL_MANAGEMENT_TEAM_MEMBER_ADDED: 'DEAL_MANAGEMENT_TEAM_MEMBER_ADDED',
  DEAL_MANAGEMENT_DEAL_OWNER_ADDED: 'DEAL_MANAGEMENT_DEAL_OWNER_ADDED'
};
exports.default = notificationTypes;